module.exports = __webpack_public_path__ + "static/media/Main_main.58c16e45.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_main.jpeg
// module id = 545
// module chunks = 0